// Fix for chunk loading errors (Unexpected token '<')
// This handles cases where JavaScript bundles fail to load and return HTML error pages instead
if (typeof window !== 'undefined') {
  // Handle dynamic import failures
  const originalError = window.addEventListener;

  window.addEventListener('error', function(event) {
    const isChunkLoadError = event.message &&
      (event.message.includes('Loading chunk') ||
       event.message.includes('Unexpected token') ||
       event.message.includes('Loading CSS chunk'));

    if (isChunkLoadError) {
      console.warn('Chunk load error detected, attempting reload:', event.message);
      // Reload the page to try loading the chunks again
      window.location.reload();
      return;
    }
  });

  // Handle unhandled promise rejections from dynamic imports
  window.addEventListener('unhandledrejection', function(event) {
    const isChunkLoadError = event.reason &&
      event.reason.message &&
      (event.reason.message.includes('Loading chunk') ||
       event.reason.message.includes('Unexpected token'));

    if (isChunkLoadError) {
      console.warn('Chunk load promise rejection, attempting reload:', event.reason.message);
      event.preventDefault();
      window.location.reload();
      return;
    }
  });
}